import type { DigitalTwinSetting } from 'api/digitalTwin/digitalTwin.types'
import { isActiveSetting, isHistorySetting } from 'helpers/optimize.helper/optimize.helper'
import Datetime from 'utils/datetime/datetime'

/** Active settings that have started, or have no start time. */
export function getCurrentActiveSettings(settings: DigitalTwinSetting[]): DigitalTwinSetting[] {
  return settings.filter(
    (setting) =>
      isActiveSetting(setting) &&
      (setting.start_time === null || Datetime.isBeforeOrEqual(setting.start_time, Datetime.getISONow()))
  )
}

/** Active settings that start later than now. */
export function getUpcomingSettings(settings: DigitalTwinSetting[]): DigitalTwinSetting[] {
  return settings.filter(
    (setting) =>
      isActiveSetting(setting) &&
      setting.start_time !== null &&
      Datetime.isAfter(setting.start_time, Datetime.getISONow())
  )
}

/** Settings that end before the next optimization hour. */
export function getHistorySettings(settings: DigitalTwinSetting[]): DigitalTwinSetting[] {
  return settings.filter((setting) => isHistorySetting(setting))
}
